// extracted by mini-css-extract-plugin
export default {"defaultLine":"#2f5be7","defaultFill":"#d9e5ff","grid":"#e7edf6","dotStroke":"#fff"};